import React from "react";
import { quarterNames } from "../models/calc";
import { rubSign } from "./format";
import styles from "./UnitEconomicsPage.module.scss";

/** Маржа по кварталам года — столбики вверх (прибыль) и вниз (убыток) от нулевой линии */
export const Sparkline = React.memo(({ values, active }: SparklineProps) => {
    const max = Math.max(1, ...values.map((v) => Math.abs(v ?? 0)));
    const height = 30;
    const half = height / 2;
    const barWidth = 10;
    const gap = 5;

    const title = values.map((v, i) => `${quarterNames[i]} кв.: ${v === null ? "нет данных" : rubSign(v)}`).join(" · ");

    return (
        <span title={title} className={styles.sparkWrap}>
            <svg
                className={styles.sparkline}
                width={values.length * (barWidth + gap)}
                height={height}
                role="img"
                aria-label={title}
            >
                <line x1={0} x2={values.length * (barWidth + gap)} y1={half} y2={half} className={styles.sparkAxis} />
                {values.map((value, index) => {
                    const x = index * (barWidth + gap) + gap / 2;
                    if (value === null) {
                        return (
                            <rect
                                key={index}
                                x={x}
                                y={half - 1}
                                width={barWidth}
                                height={2}
                                className={styles.sparkEmpty}
                            />
                        );
                    }

                    const size = Math.max(2, (Math.abs(value) / max) * (half - 1));
                    const y = value >= 0 ? half - size : half;
                    const classes = [
                        value >= 0 ? styles.sparkPositive : styles.sparkNegative,
                        active === index + 1 ? styles.sparkActive : "",
                    ].join(" ");

                    return <rect key={index} x={x} y={y} width={barWidth} height={size} rx={2} className={classes} />;
                })}
            </svg>
        </span>
    );
});

interface SparklineProps {
    values: (number | null)[];
    /** Выбранный квартал — подсвечивается */
    active?: number;
}
